import React from 'react';
import './propertiydes.css'
import Contactusd from './contactusd';
import phonee from '../../../assets/PPPIcon.svg'
import maill from '../../../assets/MAILPPIcon.svg'
import whatss from '../../../assets/WHATS0PPIcon.svg'
import Button1 from '../../farh/common/button';
const Propertiydes = (props) => {
    return ( <>
    <div className='propertydiv11'>
        <h2 className='housename'>Palm Hills Residences</h2>
        <div className='sl'>
            <h2 className='sltext'>Spectacular Living</h2>
            <div className='beddiv'>
                <h2 className='sltext'>4</h2>
                <div className='bedicon1'></div>
                <h2 className='sltext'>3</h2>
                <div className='bedicon'></div>
            </div>
        </div>
        <div className='pricediv'>
            <h2 className='priceee'>Price</h2>
            <h2 className='pricenum'>5,800,000 EGP</h2>
        </div>
        <h2 className='ourcontactss'>Or contact us directly:</h2>
        <div className='contactusdd'>
            <Contactusd 
            ppp={phonee}
            infooo='+20 100 123 4567'/>
            <Contactusd 
            ppp={maill}
            infooo='info@egyptestates.com'/>
            <Contactusd 
            ppp={whatss}
            infooo='WhatsApp Us'/>
        </div>
          <Button1 className="bypv" style2="btn1"  cta="Book your personal visit" />
    </div>
    </> );
}
 
export default Propertiydes;